/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type ContentStackPost } from '@/features/contentstack/interface/content-types';
import styles from './BlogHeading.module.scss';
import cx from 'classnames';
import { CMSHeadline } from '@/features/contentstack/components/CMSHeadline/CMSHeadline';

type BlogHeadingProps = {
  blogHeading?: ContentStackPost['post_heading'];
  isStaticPostType?: boolean;
};

export const BlogHeading = ({ blogHeading, isStaticPostType }: BlogHeadingProps) => {
  return (
    <CMSHeadline
      as="h1"
      className={cx(styles.heading, {
        [styles.mediumFont]: blogHeading?.font === 'Autozone Medium',
        [styles.heavyFont]: blogHeading?.font === 'Autozone Heavy',
        [styles.staticPostType]: isStaticPostType === true,
      })}
      underline={blogHeading?.underline}
      noGutter
    >
      {blogHeading?.heading}
    </CMSHeadline>
  );
};
